import { STORE } from "../../enums/store";
export default {
    supplier_details(state, getters, rootState) {
        if(state.selected_job.supplier_id) {
            return rootState[STORE.APP].suppliers.find(x => x.id === state.selected_job.supplier_id) || null;
        }
        return null;
    },
}